import React from 'react';
import PaymentFailure from '../../components/Payments/PaymentFailure';

const Failure = () => {
  return <PaymentFailure />;
};

export default Failure;
